<template>
  <div id="app">
   
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
window.onload = function() {
 document.addEventListener('touchstart', function(event) {
 if (event.touches.length > 1) {
  event.preventDefault()
 }
 })
 document.addEventListener('gesturestart', function(event) {
 event.preventDefault()
 })
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* overflow-y: scroll; */
  height: 100%;
 
}
</style>



// WEBPACK FOOTER //
// src/App.vue